import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  actionsIcon: {
    color: theme.palette.alternative.bright,
  },
  actionsText: {
    color: theme.palette.alternative.bright,
    margin: "0",
  },
}));
